import React, { useRef } from "react";
import "./InputDate.scss";
import { FaCalendarAlt } from "react-icons/fa";

const InputDate = ({ label, name, value, onChange, error = "" }) => {
    const inputRef = useRef(null);

    return (
        <div className="input-date-wrapper">
            {label && (
                <label htmlFor={name} className="input-date-label">
                    {label}
                </label>
            )}
            <div className="input-date-container">
                <FaCalendarAlt className="calendar-icon" />
                <input
                    type="date" 
                    id={name}
                    name={name}
                    value={value} 
                    onChange={onChange} 
                    className={`input-date ${error ? "input-error" : ""}`}
                    ref={inputRef}
                />
            </div>
            {error && <span className="input-date-error">{error}</span>}
        </div>
    );
};

export default InputDate;